import { render, staticRenderFns } from "./twoFxs.vue?vue&type=template&id=7fa80027&scoped=true&"
import script from "./twoFxs.vue?vue&type=script&lang=js&"
export * from "./twoFxs.vue?vue&type=script&lang=js&"
import style0 from "./twoFxs.vue?vue&type=style&index=0&id=7fa80027&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa80027",
  null
  
)

export default component.exports